import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { StammkundeService } from '../../../Services/stammkunde.service';
import { CustomerService } from '../../../Services/customer.service';
import { Customer } from '../../../Models/customer.model';
import { CustomerFormComponent } from '../../Wartung/customer-form/customer-form.component';
import { AuthService } from '../../../api-authorization/authorize.service';

/**
 * Übersicht aller Stammkunden. Anlegen darf nur der SuperAdmin (der Kundentyp
 * "Stammkunde" ist zusätzlich serverseitig SuperAdmin-geschützt).
 */
@Component({
  selector: 'app-stammkunden-list',
  templateUrl: './stammkunden-list.component.html',
  styleUrls: ['./stammkunden-list.component.css', '../stammkunden-theme.css']
})
export class StammkundenListComponent implements OnInit {
  stammkunden: Customer[] = [];
  filtered: Customer[] = [];
  searchTerm = '';
  loading = true;

  constructor(
    private stammkundeService: StammkundeService,
    private customerService: CustomerService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router,
    private authService: AuthService
  ) {}

  get canCreate(): boolean {
    return this.authService.canManageStammkunden();
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.stammkundeService.getStammkunden().subscribe({
      next: customers => {
        this.stammkunden = customers ?? [];
        this.applyFilter();
        this.loading = false;
      },
      error: () => {
        this.snackBar.open('Fehler beim Laden der Stammkunden', 'OK', { duration: 4000 });
        this.loading = false;
      }
    });
  }

  applyFilter(): void {
    const term = this.searchTerm.toLowerCase().trim();
    this.filtered = this.stammkunden
      .filter(c => !term || `${c.name} ${c.address ?? ''} ${c.contactPersonName ?? ''}`.toLowerCase().includes(term))
      .sort((a, b) => a.name.localeCompare(b.name, 'de'));
  }

  openCreate(): void {
    const dialogRef = this.dialog.open(CustomerFormComponent, {
      width: '880px',
      maxWidth: '96vw',
      maxHeight: '92vh',
      data: { type: 'Stammkunde' },
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.load();
        this.snackBar.open('Stammkunde angelegt', 'OK', { duration: 3000 });
      }
    });
  }

  open(customer: Customer): void {
    this.router.navigate(['/stammkunden', customer.id]);
  }

  openPlanung(customer: Customer, event: Event): void {
    event.stopPropagation();
    this.router.navigate(['/stammkunden', customer.id, 'planung']);
  }

  getLogoUrl(logoPath: string): string {
    return this.customerService.getLogoUrl(logoPath);
  }

  trackById(_: number, c: Customer): number {
    return c.id;
  }
}
